import { styled } from '@mui/material/styles';
import { Container, Paper } from '@mui/material';
import { Colors } from '../../style/theme/index';

 export const StyledContainer = styled(Container)(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
  '& .section': {
    marginBottom: theme.spacing(2),
  }, 


  '& .textup': {
   marginTop: " 16px",
  },

  

  '& .ChipGroup': {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(2),
  },

  '& .button':{
    marginTop: theme.spacing(2),
    backgroundColor: Colors.primary,
    color:  Colors.white,
    display: 'flex',
    justifyContent: 'flexEnd',
  },
  '& .button-container':{
     display: 'flex', 
     justifyContent: 'flex-end', 
     marginTop: '16px' ,
    
  }
 
}));


 

export const SavedSuggestionCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  marginTop: theme.spacing(2),
}));